<template>
    <div class="bookInfoContainer">
        <div class="head">
            <dl>
                <dt>
                    <img :src="bookInfo.cover" alt="">
                    <!-- <span>共{{bookInfo.chapters}}章</span> -->
                </dt>
                <dd>
                    <h2>{{bookInfo.bookName | valLength(22)}}</h2>  <!-- 24个字 -->
                    <p>{{ bookInfo.authorName}}&nbsp;著</p>
                    <p>{{ bookInfo.anchorName}}&nbsp;播</p>
                    <div>
                        <!-- <p>{{bookInfo.collectSum | playNum}}</p> -->
                        <p>{{ (isFinish ? '共' : '更新至') }}{{ bookInfo.chapters }}章</p>
                        <p>{{bookInfo.readSum | playNum}}次播放</p>
                    </div>
                    <div class="goHome" @click="goHome"></div>
                    <!--  -->
                </dd>
            </dl>
            <div>
                <div></div>
                <div>
                    <p>{{ bookInfo.collectSum | playNum }}人收藏</p>
                    <div>
                        <button class="collectF" v-if="!isCollect" @click="IsAddCollect">收藏</button>
                        <button class="collectT" v-if="isCollect">已收藏</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab">
            <div :class="isDescribe ? 'act' : ''" @click="getDescribe">
                <p>详情</p>
                <span></span>
            </div>
            <div :class="!isDescribe ? 'act' : ''" @click="getChapter">
                <p>章节</p>
                <span></span>
            </div>
        </div>
        <transition enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft">
            <div class="describe" v-if="isDescribe">
                <div>
                    <h2>简介</h2>
                    <p v-html="bookInfo.imageText"></p>
                </div>
            </div>
        </transition>
         <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
            <div class="chapters"  v-if="!isDescribe">
                <div class="contral">
                    <div @touchstart="goAudioStart" @click="goAudioEnd(firstChapterRank)">{{playName}}</div>
                    <div>
                        <div @click="listSort" ref="listSort">正序</div>
                        <div @click="openPage">选集</div>
                    </div>
                </div>
                <transition enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft">
                    <div class="list" v-show="!isPage" @scroll.passive="onScroll" ref="boxH">
                        <ul ref="scrollH">
                            <li :class="[item.rank == historyRank ? 'act' : '', (item.rank > showRowNum && showRowNum != -1) ? 'disClick' : '' ]" v-for="(item, index) in chapterList" :key="index"  @touchstart="goAudioStart" @touchmove="goAudioMove($event)" @click="(showRowNum == -1) ? goAudioEnd(item.rank, item) : (item.rank <= showRowNum ? goAudioEnd(item.rank, item) : '')" ref="chapterList">
                                <div>
                                    <div>
                                        <div v-show="historyRank == item.rank"></div>
                                        <div v-show="!(historyRank == item.rank)">{{item.rank}}</div>
                                    </div>
                                    <p>{{item.name}}</p>
                                    <span>{{setAudioTime(item.audioDuration)}}</span>
                                </div>
                                <div v-if="(item.rank <= showRowNum && showRowNum != -1)" class="shiting">试听</div>
                            </li>
                        </ul>
                    </div>
                </transition>
                <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
                    <div v-show="isPage" @click="closePage" class="selectPage">
                        <ul>
                            <li v-for="(item, index) in selectPage" :key="index" @click="selectPageNum(index+1)">{{item}}</li>
                        </ul>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>
<script>
let Base64 = require('js-base64').Base64;
import setTitleHack from "../assets/js/setTitle";
export default {
    // name: "书籍详情"
    data() {
        return {
            setAudioTime: this.commin.fn.setAudioTime,
            setCreatTime: this.commin.fn.setCreatTime,
            bookId: null,
            bookInfo: {},
            isFinish: false,
            isDescribe: false,
            isPage: false,
            isCollect: false,
            draw: true,
            type: 'asc',
            prevNum: -1,
            pageNum: 1,
            nextNum: -1,
            pages: -1,
            total: -1,
            direction: 'no',
            showRowNum: -1,
            historyRank: -1,
            historyDuration: -1,
            playName: "播放全部",
            chapterList: [],
            isScroll: true,
            scrollH: -1,
            firstChapterRank: 0,
            selectPage: [],
            goAudioMoveIs: true,
        }
    },
    computed: {

    },
    created() {
        var that = this;
        that.bookId = that.$route.params.id;
        // if( that.$route.query.type == 'audio' ) {
        //     that.isDescribe = false;
        //     that.getChapterList();
        // }
        that.historyRank = that.$store.state.audioInfo.rank;
        that.getBookInfo();
        that.getChapterList();
        that.$store.commit("setToAudioPage", "");
    },
    destroyed () {
        var that = this;
        // that.Bus.$off(['goAudio']);
    },
    methods: {
        getBookInfo() {
            var that = this;
            var data = {
                bookId: that.bookId,
                ticket: localStorage.getItem("ticket")
            }
            that.allApi.getBook(data).then((resource)=>{
                // console.log(resource.data.data)
                that.bookInfo = resource.data.data;

                setTitleHack( that.bookInfo.bookName + "-" + localStorage.getItem("officeName") );

                if( that.bookInfo.finished == 'Y' ) {
                    that.isFinish = true;
                }else{
                    that.isFinish = false;
                }

                if( !resource.data.data.collectId ){
                    that.isCollect = false;
                }else{
                    that.isCollect = true;
                }

                if( resource.data.data.listenAll == 'N') {
                    // 机构设置不让未登录听取已购书籍全部章节
                    
                    if( localStorage.getItem("status") == "false" || !localStorage.getItem("status") ) {
                        // 未登录
                        that.showRowNum = resource.data.data.showChapters;
                        localStorage.setItem("showRowNum", resource.data.data.showChapters);
                    }else{
                        // 已登录
                        if( new Date().getTime() > new Date(localStorage.getItem("expireDate")).getTime() && localStorage.getItem("expireDate") != -1 ) {
                            // 用户账号到期
                            that.showRowNum = resource.data.data.showChapters;
                            localStorage.setItem("showRowNum", resource.data.data.showChapters);
                        }else{
                            // 用户账号未到期
                            if( localStorage.getItem("userType") == "1" ) {
                                // 普通用户
                                that.showRowNum = resource.data.data.showChapters;
                                localStorage.setItem("showRowNum", resource.data.data.showChapters);
                            }else if( localStorage.getItem("userType") == "0" ){
                                // 会员用户
                                if( resource.data.data.bought == 'N' ) {
                                    // 未购买
                                    that.showRowNum = resource.data.data.showChapters;
                                    localStorage.setItem("showRowNum", resource.data.data.showChapters);
                                }else{
                                    localStorage.removeItem("showRowNum");
                                }
                            }    
                        }
                    }
                }else{
                    // 机构设置允许未登录听取已购书籍全部章节
                    if( resource.data.data.bought == 'N' ) {
                        // 未购买
                        that.showRowNum = resource.data.data.showChapters;
                        localStorage.setItem("showRowNum", resource.data.data.showChapters);
                    }else{
                        // 已购买
                        localStorage.removeItem("showRowNum");
                    }
                }
            })
        },
        IsAddCollect() {
            var that = this;
            if( localStorage.getItem("errMsg") ) {
                // that.errMsg = localStorage.getItem("errMsg");
                let data = {
                    msg: localStorage.getItem("errMsg")
                }
                that.$emit("dialogChange", data);
            }else{
                if( localStorage.getItem("status") == 'false' ) {
                    let data = {
                        msg: "收藏需先登录，以便保存您的收藏记录"
                    }
                    that.$emit("dialogChange", data);
                    // let flat = confirm("收藏需先登录，以便保存您的收藏记录");
                    // if( flat ) {
                    //     that.$router.push("/login");
                    // }
                }else{
                    var data = {
                        bookId: that.bookId,
                        deptBookId: that.bookInfo.deptBookId,
                        ticket: localStorage.getItem("ticket")
                    }
                    that.allApi.addUserBookCollect(data).then((resource)=>{
                        that.isCollect = true;
                        that.getBookInfo();
                    })
                }
            }
            
        },
        getChapterList() {
            var that = this;
            var data = {
                historical: that.draw,
                rankOrder: that.type,
                bookId: that.bookId,
                ticket: localStorage.getItem("ticket"),
                page: {
                    pageSize: 20,
                }
            }
            
            if( that.direction == "prev" ) {
                data.page.pageNum = that.prevNum;
            }else if( that.direction == "next" ) {
                data.page.pageNum = that.nextNum;
            }else{
                data.page.pageNum = that.pageNum;
            }
            // console.log(data)

            that.allApi.getChapter(data).then((resource)=>{
                // console.log(resource.data)

                
                if( data.historical ) {
                    // 历史记录历史播放章节与历史音频播放时间
                    if( resource.data.data.historyRank ) {
                        that.historyRank = resource.data.data.historyRank;
                        that.historyDuration = resource.data.data.history.duration;
                    }else{
                        that.historyRank = -1;
                        that.historyDuration = 0;
                    }
                }

                // 章节列表拼接
                if( that.direction == "prev" ) {
                    that.chapterList = resource.data.data.pageQuery.list.concat(that.chapterList);
                }else if( that.direction == "next" ) {
                    that.chapterList = that.chapterList.concat(resource.data.data.pageQuery.list);
                }else{
                    // 此书籍在该版本中，获取所有数据
                    that.prevNum = resource.data.data.pageQuery.pageNumber;
                    that.pageNum = resource.data.data.pageQuery.pageNumber;
                    that.nextNum = resource.data.data.pageQuery.pageNumber;
                    that.pages = resource.data.data.pageQuery.totalPage;
                    that.total = resource.data.data.pageQuery.totalRow;
                    that.chapterList = resource.data.data.pageQuery.list;
                }

                if( that.type == 'asc' && !localStorage.getItem('showRowNum') && that.historyRank == -1 ) {
                    
                    // 点击播放全部时  正序播放第一章  登录状态下  非历史
                    // that.firstChapter = resource.data.data.pageQuery.list[0];
                    that.playName = '播放全部';
                    that.firstChapterRank = 1;

                }else if( that.type == 'desc' && !localStorage.getItem('showRowNum') && that.historyRank == -1 ) {
                    
                    // 点击播放全部时  倒序播放最后一章  登录状态下  非历史
                    // that.firstChapter = resource.data.data.pageQuery.list[0];
                    that.firstChapterRank = resource.data.data.pageQuery.totalRow;
                    that.playName = '播放全部';

                }else if( (that.type == 'asc' || that.type == 'desc') && localStorage.getItem('showRowNum') ) {
                    
                    // 点击播放全部时  正序播放第一章  未登录状态下  非历史
                    // that.firstChapter = resource.data.data.pageQuery.list[0];
                    that.firstChapterRank = 1;
                    that.playName = '播放全部';

                }else if( !localStorage.getItem('showRowNum') && that.historyRank != -1 ) {
                    
                    // 点击继续播放时  继续播放  登录状态下  历史
                    // that.firstChapter = resource.data.data.pageQuery.list[resource.data.data.historyRank % 20 - 1];
                    that.firstChapterRank = that.historyRank;
                    that.playName = '继续播放';

                }
                // console.log(that.firstChapterRank)
                
                that.$nextTick(()=>{
                    that.isScroll = true;
                    that.scrollH = that.$refs.scrollH.offsetHeight;
                    if( resource.data.data.historyRank ) {
                        // 历史记录进来记录的播放历史章节显示在最上面
                        that.$refs.boxH.scrollTop = that.$refs.chapterList[(resource.data.data.historyRank-1)%20].offsetHeight * ((resource.data.data.historyRank-1)%20);
                    }
                    
                })
            })
        },
        onScroll() {
            // 章节滚动 上拉下拉
            var that = this;
            var boxH = that.$refs.boxH.offsetHeight;
            var boxTop = that.$refs.boxH.scrollTop;
            if( that.scrollH - boxH - boxTop < 30 && that.isScroll ) {
                if( that.nextNum + 1 > that.pages ){
                    that.nextNum = that.pages;
                    return false;
                }else{
                    that.direction = "next";
                    that.isScroll = false;
                    that.nextNum ++;
                    that.draw = false;
                    that.getChapterList();
                }
            }else if( boxTop <= 0 && that.isScroll ) {
                if( that.prevNum - 1 < 1 ){
                    that.prevNum = 1;
                    return false;
                }else{
                    that.direction = "prev";
                    that.isScroll = false;
                    that.prevNum --;
                    that.draw = false;
                    that.getChapterList();
                }
            }
        },
        sortRule(){
            var that = this;
            var arr = [];
            if( that.type == "asc" ){
                // 正序章节按页数排序 1~20  21~40
                for( var i=0,len=that.pages; i<len; i++ ){
                    if( (i+1)*20 > that.total ) {
                        arr.push( (i*20+1) + "-" + that.total );
                    }else{
                        arr.push( (i*20+1) + "-" + ((i+1)*20) );
                    }
                }
            }else if( that.type == "desc" ){
                // 倒序章节按页数排序  40~21  20~1
                for( var i=0,len=that.pages; i<len; i++ ){
                    if( that.total-((i+1)*20)+1 < 1 ) {
                        arr.push( (that.total-(i*20)) + "-" + 1 );
                    }else{
                        arr.push( (that.total-(i*20)) + "-" + (that.total-((i+1)*20)+1) );
                    }
                }
            }
            that.selectPage = arr;
        },
        listSort() {
            // 点击排序
            var that = this;
            that.type = that.type == "asc" ? "desc" : "asc";
            that.$refs.listSort.innerHTML = that.type == "asc" ? "正序" : "倒序" ;
            that.$refs.listSort.style.backgroundImage = that.type == "asc" ? "url('"+ require('../assets/imgs/bookInfo/asc.png') +"')" : "url('"+ require('../assets/imgs/bookInfo/desc.png') +"')";
            that.pageNum = 1;
            that.direction = "no";
            that.draw = false;
            that.getChapterList();
            that.sortRule();
        },
        getDescribe() {
            // tab 选中简介详情
            var that = this;
            that.isDescribe = true;
            that.isPage = false;
        },
        getChapter() {
            // tab 选中章节
            var that = this;
            that.isDescribe = false;
            that.draw = true;
            that.getChapterList();
        },
        openPage() {
            // 弹出选集浮窗
            var that = this;
            that.isPage = true;
            that.sortRule();
        },
        selectPageNum(num) {
            // 选中其中一集  并关闭选集浮窗
            var that = this;
            that.chapterList = [];
            that.pageNum = num;
            that.direction = "no";
            that.draw = false;
            that.getChapterList();
        },
        closePage() {
            // 关闭选集浮窗
            var that = this;
            that.isPage = false;
        },
        goAudioStart(){
            var that = this;
            // var audioInfo = {
            //     isPlay: false
            // }

            // that.$store.commit("setAudioInfo", audioInfo);
        },
        goAudioMove(e) {
            var that = this;
            that.goAudioMoveIs = false;
        },
        goAudioEnd(rank, chapterInfo) {
            // 跳转到播放页并设置全局变量一遍后台小播放器使用
            var that = this;

            if( !that.goAudioMoveIs ) {

                that.goAudioMoveIs = true;
                return false;

            }

            var pageNum = -1;
            if( rank % 20 != 0 ) {
                pageNum = Math.floor(rank / 20) + 1;
            }else{
                pageNum = Math.floor(rank / 20);
            }

            if( that.historyRank != rank ) {
                that.$store.commit("clearAddHistory");
            }

            let actChapter = {
                actChapterIdx: (rank % 20 != 0) ? (rank % 20 - 1) : 19,
                rank: rank,
            }
            that.$store.commit("setActChapter", actChapter);

            let chapterHistory = {
                historyRank: that.historyRank ? that.historyRank : rank,
            }

            that.$store.commit("setChapterHistory", chapterHistory);

            let chapterPages = {
                pageNum: pageNum,
                prevNum: pageNum,
                nextNum: pageNum,
            }

            that.$store.commit("setChapterPages", chapterPages);

            let audioInfo = {
                currentTime: (that.historyRank == rank) ? that.historyDuration : 0,
            }

            if( that.$store.state.audioInfo.isPlay == "n" ){
                audioInfo.isPlay = "y"
            }
            
            that.$store.commit("setAudioInfo", audioInfo);
            
            that.$store.commit("setToAudioPage", "book");

            that.$router.push(`/audio/${that.bookId}`)
        },
        goHome() {
            var that = this;
            that.$router.push({
                path: `/home`
            });
        },
    },
    watch: {
        
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
@keyframes playIco{
    0% {
        background: url('../assets/imgs/audios/playIco1.png') center/ rem(40px) rem(36px) no-repeat;
    }
    25% {
        background: url('../assets/imgs/audios/playIco2.png') center/ rem(40px) rem(36px) no-repeat;
    }
    50% {
        background: url('../assets/imgs/audios/playIco3.png') center/ rem(40px) rem(36px) no-repeat;
    }
    75% {
        background: url('../assets/imgs/audios/playIco4.png') center/ rem(40px) rem(36px) no-repeat;
    }
    100% {
        background: url('../assets/imgs/audios/playIco5.png') center/ rem(40px) rem(36px) no-repeat;
    }
}
.bookInfoContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    z-index: 2;
    background: #fff;
    .head{
        padding: rem(50px) rem(55px) rem(30px);
        >dl{
            display: flex;
            >dt{
                display: block;
                width: rem(200px);
                height: rem(200px);
                position: relative;
                border-radius: rem(10px);
                overflow: hidden;
                margin-right: rem(30px);
                >img{
                    display: block;
                    width: 100%;
                    height: 100%;
                    // background: red;
                }
                // >span{
                //     position: absolute;
                //     left: rem(12px);
                //     bottom: rem(12px);
                //     background: rgba(17, 17, 17, .7);
                //     height: rem(32px);
                //     line-height: rem(32px);
                //     color: #4A90E2; 
                //     padding: 0 rem(5px);
                // }
            }
            >dd{
                padding-bottom: rem(10px);
                display: flex;
                width: 0%;
                flex: 1;
                justify-content: space-between;
                flex-direction: column;
                border-bottom: 1px solid #e1e1e1;
                height: rem(200px);
                >h2{
                    font-size: rem(30px);
                    // line-height: rem(45px);
                    color: #111;
                    margin-bottom: rem(5px);
                    padding-right: rem(45px);
                }
                >p{
                    font-size: rem(20px);
                    // line-height: rem(36px);
                    color: #a4a4b7;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin-bottom: rem(5px);
                }
                >div{
                    overflow: hidden;
                    >p{
                        float: left;
                        margin-right: rem(15px);
                        font-size: rem(20px);
                        // line-height: rem(33px);
                        color: #a4a4b7;
                    }
                }
                .goHome{
                    position: absolute;
                    right: 0;
                    top: rem(30px);
                    width: rem(100px);
                    height: rem(40px);
                    background: url('../assets/imgs/audios/goHome.png') center / rem(100px) rem(40px) no-repeat;
                }
            }
        }
        >div{
            overflow: hidden;
            padding: rem(30px) 0 0;
            display: flex;
            >div:first-child{
                margin-right: rem(30px);
                width: rem(200px);
            }
            >div:last-child{
                flex: 1;
                display: flex;
                justify-content: space-between;
                >p{
                    font-size: rem(24px);
                    line-height: rem(55px);
                    color: #a4a4b7;
                }
                >div{
                    >.collectF{
                        outline: none;
                        border: 0;
                        border-radius: rem(55px);
                        height: rem(55px);
                        line-height: rem(55px);
                        padding: 0 rem(60px) 0 rem(20px);
                        background: url('../assets/imgs/bookInfo/collect.png') rem(85px) center / rem(26px) no-repeat, #007AFF;
                        color: #fff;
                        font-size: rem(24px);
                    }
                    >.collectT{ 
                        outline: none;
                        border: 0;
                        border-radius: rem(55px);
                        width: rem(128px);
                        height: rem(55px);
                        line-height: rem(55px);
                        color: #fff;
                        background: #007AFF;
                        font-size: rem(24px);
                    }
                }
            }
        }
    }
    .tab{
        background: #F8FAFD;
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #f5f5f5;
        >div{
            font-size: rem(28px);
            line-height: rem(80px);
            color: #111;
            position: relative;
            >span{
                position: absolute;
                left: 10%;
                bottom: rem(0px);
                height: rem(4px);
                background: #fff;
                width: 80%;
            }
            &.act{
                color: #007AFF;
                >span{
                    background: #007AFF;
                }
            }
        }
    }
    .describe{
        position: absolute;
        left: 0;
        top: rem(454px);
        bottom: 0;
        right: 0;
        // border-top: 1px solid #f5f5f5;
        // background: #F8FAFD;
        padding: rem(60px) rem(50px) 0;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        >div{
            >h2,
            >p{
                font-weight: normal;
                font-size: rem(28px);
                line-height: rem(37px);
                color: #111;
            }
            >h2{
                margin-bottom: rem(25px);
            }
        }
    }
    .chapters{
        position: absolute;
        left: 0;
        top: rem(454px);
        bottom: 0;
        right: 0;
        
        // background: #F8FAFD;
        padding: rem(16px) rem(50px) 0;
        >.contral{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: rem(20px);
            >div:first-child{
                width: rem(150px);
                height: rem(42px);
                line-height: rem(42px);
                font-size: rem(24px);
                padding-left: rem(40px);
                border-radius: rem(6px);
                background-image: url('../assets/imgs/bookInfo/play.png');
                background-size: rem(12px) rem(20px);
                background-position: rem(16px) center;
                background-repeat: no-repeat;
                background-color: #89C0FB;
                color: #fff;
            }
            >div:last-child{
                display: flex;
                >div{
                    color: #007AFF;
                    font-size: rem(24px);
                    line-height: rem(33px);
                    padding-left: rem(38px);
                    background-image: url('../assets/imgs/bookInfo/asc.png');
                    background-size: rem(28px) rem(28px);
                    background-position: left center;
                    background-repeat: no-repeat;
                    &:last-child{
                        margin-left: rem(38px);
                        padding-left: rem(33px);
                        background-size: rem(23px) rem(28px);
                        background-image: url('../assets/imgs/bookInfo/selectPage.png');
                    }
                }
            }
        }
        >.list{
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: rem(78px);
            padding: 0 rem(50px);
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            >ul{
                >li{
                    border-bottom: 1px solid #E5E5E5;
                    padding: rem(30px) rem(10px);
                    display: flex;
                    flex-direction: column;
                     >div:first-child{
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: rem(10px);
                        >div{
                            width: rem(40px);
                            height: rem(36px);
                            margin-right: rem(15px);
                            text-align: center;
                            color: #333;
                            >div:first-child{
                                height: rem(34px);
                                animation: playIco 1.5s infinite;
                            }
                        }
                        >p{
                            width: 0%;
                            flex: 1;
                            font-size: rem(28px);
                            line-height: rem(40px);
                            height: rem(40px);
                            color: #333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            margin-right: rem(15px);
                        }
                        >span{
                            display: block;
                            font-size: rem(20px);
                            line-height: rem(40px);
                            height: rem(40px);
                            color: #a4a4b7;
                            padding-left: rem(30px);
                            background: url('../assets/imgs/bookInfo/duration.png') center left / rem(20px) no-repeat;
                        }
                    }
                    >div.shiting{
                        font-size: rem(24px);
                        color: #007AFF;
                        border: 1px solid #007AFF;
                        width: rem(80px);
                        text-align: center;
                        line-height: rem(34px);
                        border-radius: rem(5px);
                        height: rem(36px);
                    }
                    &.act{
                        >p{
                            color: #007AFF;
                        }
                    }
                    &.disClick{
                        >div:first-child{
                            color: #a4a4b7;
                            >p{
                                color: #a4a4b7;
                            }
                        }
                        
                    }
                }
            }
        }
        .selectPage{
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: rem(78px);
            padding: 0 rem(50px);
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    border-radius: rem(6px);
                    width: rem(145px);
                    height: rem(55px);
                    line-height: rem(51px);
                    font-size: rem(28px);
                    border: 1px solid #65ADEF;
                    color: #65ADEF;
                    text-align: center;
                    margin: rem(10px) rem(8px);
                }
            }
        }
    }
}
</style>
